<template>
  <div
    :id="id"
    data-component-name="ExpertiseTab"
    :data-title="title"
    v-show="isActive"
  >
    <slot />
  </div>
</template>

<script setup>
import { getUniqueId } from '@/shared/utils/uniqueId.js'
import { computed, inject } from 'vue'

defineProps({
  title: {
    type: String,
    required: true,
  },
})

const id = `growthmentor-expertise-tab-${getUniqueId()}`
const activeTab = inject('activeTab')

const isActive = computed(() => activeTab.value?.id === id)

defineExpose({
  id,
})
</script>
